const emailValidation = (email: string) => {
  let isValidEmail: boolean = false;
  let validEmailStatus: string = "";

  // Regex for validating email
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  if (emailRegex.test(email)) {
    isValidEmail = true;
    validEmailStatus = "";
    return { isValidEmail, validEmailStatus };
  } else {
    isValidEmail = false;
    validEmailStatus = "Invalid Email";
    return { isValidEmail, validEmailStatus };
  }
};

export default emailValidation;
